import { ChevronRightIcon } from '@heroicons/react/20/solid';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function Breadcrumb({ pages }) {
    return (
        <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
                {/* <li>
                    <div>
                        <a className="text-gray-400 hover:text-gray-500">
                            <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                            <span className="sr-only">Home</span>
                        </a>
                    </div>
                </li> */}
                <li className="flex h-11">
                    <div className="flex items-center">
                        <a
                            href="/classifications"
                            className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                            Classifications
                        </a>
                    </div>
                </li>
                {pages.map((page, index) => (
                    <li key={index}>
                        <div className="flex items-center">
                            {/* <svclassg
                                className="h-5 w-5 flex-shrink-0 text-gray-300"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                aria-hidden="true"
                            >
                                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                            </svg> */}
                            <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />

                            <a
                                href={page.href}
                                // className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                aria-current={page.current ? 'page' : undefined}
                                className={classNames(page.current ? "text-indigo-500 hover:text-indigo-700" : "", "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700")}
                            >
                                {page.name}
                            </a>
                        </div>
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default Breadcrumb;